var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9, 6)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0 C9.76142375,0 12,2.23857625 12,5 C12,7.76142375 9.76142375,10 7,10 C4.23857625,10 2,7.76142375 2,5 L2.005,4.783 C2.12117822,2.10860463 4.32308238,0.000154662074 7,0 L7,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,12 C11.7614237,12 14,14.2385763 14,17 L14,18 C14,19.1045695 13.1045695,20 12,20 L2,20 C0.8954305,20 0,19.1045695 0,18 L0,17 C0,14.2385763 2.23857625,12 5,12 L9,12 L9,12 Z"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgUser);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/user.0424592f89e37cfdd3bcf0c59b9d7b4a.svg";